import React from 'react';

const Loading = () => {
    return (
        <div className='center'>
            <div className="loader"></div>
        </div>
        
    );
};

export default Loading;